import React from "react";
import { Col } from "reactstrap";
import DashPanel from "../common/DashPanel";
import SectionTitle from "../common/SectionTitle";
import StatBadgeRow from "../common/StatBadgeRow";
import ProgressRow from "../common/ProgressRow";
import { T } from "../../constants/theme";
import { userPartyData } from "../../data/dashboardMockData";

const ROLE_COLORS = [T.blue, T.green, T.teal, T.yellow, T.purple, T.orange];

const UserAnalyticsSection = ({ loading }) => (
  <Col xl={6} className="d-flex">
    <DashPanel
      title="User Analytics"
      icon="bx bx-user-circle"
      iconColor={T.teal}
      loading={loading}
    >
      <StatBadgeRow
        items={[
          { label: "Total", value: userPartyData.users.total, color: T.teal },
          { label: "Active", value: userPartyData.users.active, color: T.green },
          { label: "Never Logged In", value: userPartyData.users.neverLoggedIn, color: T.red },
          { label: "Logged In Today", value: userPartyData.users.loggedInToday, color: T.blue },
        ]}
        loading={loading}
      />

      <SectionTitle>Users by Role</SectionTitle>
      {userPartyData.users.byRole.map((r, i) => (
        <ProgressRow
          key={i}
          label={r.role}
          value={r.count}
          max={userPartyData.users.total || 1}
          color={ROLE_COLORS[i % 6]}
          loading={loading}
        />
      ))}

      {/* <SectionTitle style={{ marginTop: "12px" }}>Party Types</SectionTitle>
      {userPartyData.parties.byType.map((p, i) => (
        <ProgressRow key={i} label={p.type} value={p.count} max={userPartyData.parties.total || 1}
          color={[T.blue, T.green, T.orange, T.purple][i % 4]} loading={loading} />
      ))} */}
    </DashPanel>
  </Col>
);

export default UserAnalyticsSection;
